export enum GambitType {
    DonotIntakeOnHoldReason_DonorRemoteStatus       = 1,
    DonotIntakeOnHoldReason_ConnectToDonorStatus    = 2,
}